import { render } from "./PendingDsoInfo.vue?vue&type=template&id=6a362438"
import script from "./PendingDsoInfo.vue?vue&type=script&lang=js"
export * from "./PendingDsoInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__